export const THEME_STORAGE_KEY = 'carteiro-admin-theme';

export const THEMES = {
	DARK: 'dark',
	LIGHT: 'light',
};

export const DEFAULT_THEME = THEMES.DARK;

export const isThemeValid = (theme) => Object.values(THEMES).includes(theme);

export const resolveStoredTheme = () => {
	if (typeof window === 'undefined') return DEFAULT_THEME;

	try {
		const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
		return isThemeValid(storedTheme) ? storedTheme : DEFAULT_THEME;
	} catch (error) {
		return DEFAULT_THEME;
	}
};

export const applyTheme = (theme) => {
	if (typeof document === 'undefined') return;

	const resolvedTheme = isThemeValid(theme) ? theme : DEFAULT_THEME;

	document.documentElement.dataset.theme = resolvedTheme;
	document.documentElement.style.colorScheme = document.documentElement.classList.contains(
		'ca-modern-surface',
	)
		? resolvedTheme
		: THEMES.LIGHT;
};

export const persistTheme = (theme) => {
	if (typeof window === 'undefined') return;

	try {
		window.localStorage.setItem(THEME_STORAGE_KEY, theme);
	} catch (error) {
		// Ignore storage failures to avoid breaking the UI.
	}
};

export const setTheme = (theme) => {
	const resolvedTheme = isThemeValid(theme) ? theme : DEFAULT_THEME;
	applyTheme(resolvedTheme);
	persistTheme(resolvedTheme);
	return resolvedTheme;
};

export const initializeTheme = () => {
	const theme = resolveStoredTheme();
	applyTheme(theme);
	return theme;
};
